import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-color-grp-menu',
  templateUrl: './color-grp-menu.component.html',
  styleUrls: ['./color-grp-menu.component.css']
})
export class ColorGrpMenuComponent implements OnInit {
    colorGrpId;

    public colourGroupNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'colorgrplang', gotoParms: () => this.menu!.colorgrp_id ?? '' }];

    public menu?: Menu;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.colorGrpId = this.stateService.getStateParams()['colorgrp_id'];
    }

    private async loadMenu() {
        if (!!this.colorGrpId) {
            this.menu = (await this.datatask.Post(1206, { colorgrp_id: this.colorGrpId }))[0];
        }
    }

    public async deleteValues() {
        if (!!this.menu) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(1207, this.menu))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    colorgrp_id: string;
    colorgrp_name: string;
    sortorder: string;
}
